import { baseEnvironment } from "./environment.base";

export const environment = {
	...baseEnvironment,
	production: false,
	AZURE_CLIENT_ID: "60c4656b-b71f-4bad-b26d-c8fc72c95f98",
	urlClientApp: "https://coreautomatizaciones-proveedor-dev.ipt.pe",
	urlPortalOrigin: "https://proveedores-dev.ipt.pe",
	authProvider: "prov-auth",
	urlBackendAuth: "https://gestion-usuarios-dev.ipt.pe",
	urlBackendPortal: "https://authorization-api-dev.ipt.pe", // https://authorization-api-dev.ipt.pe
	urlBackendAlarmsEvents: "https://alarmas-eventos-dev.ipt.pe",
	urlBackendFlujoBajas: "https://core-automatizaciones-dev.ipt.pe",
	urlEventosCampos: "https://eventos-campos-dev.ipt.pe",
	urlApiGateway: "https://api-inventory-dev.ipt.pe",
	topologyToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InVzZXJfYXBpIiwibmFtZSI6IlVzZXIgQVBJIn0.1pz5m2gTdl8gGo3GsmTbiTD8xqCBnKJ_is0c3FE0mOQ",
	urlApiTopology: "https://topologias-backend-dev.ipt.pe",
	urlApiInventory: "https://inventario-sites-dev.ipt.pe",
	NEXT_PUBLIC_GA_MEASUREMENT_ID: "G-R0GBJS75S0",
	GA_API_SECRET: "Jq-OMXr2QTS0xGgVobwRZA",
};
